/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Rank_Storyline_HintInputs */



/**
* | output |
* | --- |
* | "Storyline events cannot be championships — the VEKN calendar has no Storyline championship type." |
*
* @param {Tfield_Rank_Storyline_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_rank_storyline_hint = /** @type {((inputs?: Tfield_Rank_Storyline_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Rank_Storyline_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les événements Storyline ne peuvent pas être des championnats — le calendrier VEKN n'a pas de type championnat Storyline.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los eventos Storyline no pueden ser campeonatos — el calendario VEKN no tiene un tipo de campeonato Storyline.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Eventos Storyline não podem ser campeonatos — o calendário VEKN não tem um tipo de campeonato Storyline.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gli eventi Storyline non possono essere campionati — il calendario VEKN non ha un tipo campionato Storyline.")
	return /** @type {LocalizedString} */ ("Storyline events cannot be championships — the VEKN calendar has no Storyline championship type.")
});